import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'interfaces';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/base/mfa'] || initialState;

export const selectMfaLoader = createSelector([selectDomain], (mfaState) => mfaState.loading);
export const selectMfaState = createSelector([selectDomain], (mfaState) => mfaState.mfaState);
export const selectMfaConfigStatus = createSelector(
  [selectDomain],
  (mfaState) => mfaState.mfaState.mfaConfigStatus,
);
export const selectShowMfaSelection = createSelector(
  [selectDomain],
  (mfaState) => mfaState.mfaState.showMfaSelection,
);
export const selectMfaConfigs = createSelector(
  [selectDomain],
  (mfaState) => mfaState.mfaState.mfaConfigs,
);
export const selectSelectedMfaType = createSelector(
  [selectDomain],
  (mfaState) => mfaState.mfaState.selectedMfaType,
);
export const selectMfaChallengeId = createSelector(
  [selectDomain],
  (mfaState) => mfaState.mfaState.challengeId,
);
export const selectMfaOriginalCredentials = createSelector(
  [selectDomain],
  (mfaState) => mfaState.mfaState.originalCredentials,
);

export const selectMfaError = createSelector(
  [selectDomain],
  (mfaState) => mfaState.error,
);
